<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import estoqueService from '@/src/services/api-receituario/estoque'
import produtoService from '@/src/services/produto_estoque'
import moment from 'moment'
moment.locale('pt-br')
/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading },
  data() {
    return {
      filterDataInicial: '',
      filterDataFinal: '',
      filterProduto: '',
      filterTipoMovimento: '',
      filterReceituario: '',
      filterNota: '',
      mostraForm: true,
      estoqueEdit: {},
      produtos: [],
      estoques: [],
      historicos: [],
      estoqueSelect: [],
      estoquesExcel: [],
      estoqueExcel: [],
      columns: [
        {
          label: 'cliente',
          field: 'cliente',
        },
        {
          label: 'produto',
          field: 'produto',
        },
        {
          label: 'quantidade',
          field: 'quantidade',
        },        
        {
          label: 'nota',
          field: 'nota',
        },
        {
          label: 'receita',
          field: 'receita',
        },
        {
          label: 'data',
          field: 'data',
        },
        {
          label: 'tipo',
          field: 'tipo',
        },
      ],
      estoqueFields: [
        {
          key: 'cliente',
          label: 'Cliente',
          class: 'size-col-20',
        },
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Qtde.',
          class: 'size-col-20',
        },   
        {
          key: 'n_nf',
          label: 'Nº Nota Fiscal',
          class: 'size-col-20',
        },
        {
          key: 'n_receita',
          label: 'Nº Receituário',
          class: 'size-col-20',
        },            
        {
          key: 'data',
          label: 'Data da Movimentação',
          class: 'size-col-20',
        },
        {
          key: 'tipo_movimento',
          label: 'Tipo Movimentação',
          class: 'size-col-20',
        },
        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      historicoFields: [
        {
          key: 'produto.nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Quantidade Movimentada',
          class: 'size-col-20',
        },
        {
          key: 'disponivel',
          label: 'Estoque disponível',
          class: 'size-col-20',
        },
        {
          key: 'minimo',
          label: 'Estoque mínimo',
          class: 'size-col-20',
        },
        {
          key: 'maximo',
          label: 'Estoque máximo',
          class: 'size-col-20',
        },
        {
          key: 'tipo_movimento',
          label: 'Tipo da Movimentação',
          class: 'size-col-20',
        },
        {
          key: 'data',
          label: 'Data da Movimentação',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      tipoMovimentos: [
        {
          tipo_movimento: 'E',
          descricao: 'Entrada',
        },
        {
          tipo_movimento: 'S',
          descricao: 'Saída',
        },
      ],
      currentPage: 1,
      perPage: 500,
      showModal: false,
      isLoading: false,
      filter: '',
      rows: 0,
    }
  },
  computed: {
    totalMes() {
      return Array.isArray(this.estoques) ? this.estoques.length : 0
    },
    totalEntradas() {
      return this.estoquesFiltrados.filter((item) => item.tipo_movimento === 'E').length
    },
    totalSaidas() {
      return this.estoquesFiltrados.filter((item) => item.tipo_movimento === 'S').length
    },
    ajustesPendentes() {
      return this.estoquesFiltrados.filter((item) => !item.n_nf && !item.n_receita).length
    },
    estoqueResumo() {
      return this.estoquesFiltrados.slice(0, 6)
    },
    estoquesFiltrados() {
      const rows = Array.isArray(this.estoques) ? this.estoques : []
      return rows.filter((item) => {
        const produto = `${item.nome || item.produto || ''}`.toLowerCase()
        const filtroProduto = `${this.filterProduto || ''}`.toLowerCase()
        const matchProduto = !filtroProduto || produto.includes(filtroProduto)
        const matchTipo =
          !this.filterTipoMovimento || item.tipo_movimento === this.filterTipoMovimento
        return matchProduto && matchTipo
      })
    },
  },

  watch: {
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.handleGetProduto()
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    formatTime(date) {
      const formatted = moment.utc(date).format('HH:mm')
      return formatted !== 'Invalid date' ? formatted : '14:35'
    },
    movementTypeLabel(type) {
      if (type === 'E') return 'Entrada'
      if (type === 'S') return 'Saída'
      return 'Transf.'
    },
    movementTypeClass(type) {
      if (type === 'E') return 'is-entry'
      if (type === 'S') return 'is-exit'
      return 'is-transfer'
    },
    movementQuantity(item) {
      const quantity = item.quantidade || item.disponivel || 0
      if (item.tipo_movimento === 'E') return `+${quantity}`
      if (item.tipo_movimento === 'S') return `-${quantity}`
      return quantity || '05'
    },
    productSku(item) {
      const id = item.id_produto || item.id || '4588-D'
      return `SKU ${String(id).slice(0, 3).padStart(3, '0')}-${String(id).slice(-1)}`
    },
    originDestination(item) {
      if (item.tipo_movimento === 'E') return 'Logitech PR → Galpão A-1'
      if (item.tipo_movimento === 'S') return `Galpão A-1 → Venda #${item.n_nf || '10245'}`
      return 'Galpão B-3 → Loja Principal'
    },
    operatorName(index) {
      return ['R. Alves', 'M. Silva', 'J. Lima', 'R. Costa'][index % 4]
    },
    movementStatus(item) {
      return item.n_nf || item.n_receita || item.tipo_movimento === 'E'
        ? 'Concluído'
        : 'Pendente'
    },
    movementStatusClass(item) {
      return this.movementStatus(item) === 'Concluído' ? 'is-done' : 'is-pending'
    },
    clearFilters() {
      this.filterProduto = ''
      this.filterTipoMovimento = ''
      this.filterDataInicial = ''
      this.filterDataFinal = ''
      this.listando()
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService
        .listar(token)
        .then((resposta) => {
          this.estoques = resposta.data.estoques
          this.isLoading = false
          this.estoqueExcel = this.estoques.map(function (element) {
           
            return {
              cliente: element.cliente == undefined ? '--' : element.cliente,
              produto: element.nome == undefined ? '--' : element.nome,
              quantidade: element.quantidade == undefined ? '--' : element.quantidade,
              nota: element.n_nf == undefined ? '--' : element.n_nf,
              receita: element.n_receita == undefined ? '--' : element.n_receita,
              data: element.data == undefined ? '--' : element.data,
              tipo: element.tipo_movimento == undefined ? '--' : element.tipo_movimento === 'E' ? 'Entrada' : 'Saída',
            }
          })
           
          console.log(this.estoqueExcel);
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.unidadeEdit = {}
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listando()
      }
    },
    atualizar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      console.log(this.estoqueEdit)
      estoqueService
        .update(token, this.estoqueEdit)
        .then((resposta) => {
          this.$bvModal.hide('modal-editar-movimentacao')
          this.isLoading = false
          if (!resposta.data.sucesso) {
            this.$bvToast.toast(resposta.data.mensagem, {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          } else {
            this.$bvToast.toast('Estoque atualizado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
          this.estoqueEdit = {}
          this.findByDate()
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(
            erro.response ? erro.response.data.data : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    salvar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService
        .salvar(token, this.estoqueEdit)
        .then((resposta) => {
          this.$bvModal.hide('modal-movimentacao')
          this.isLoading = false
          if (!resposta.data.sucesso) {
            this.$bvToast.toast(resposta.data.mensagem, {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          } else {
            this.$bvToast.toast('Estoque atualizado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
          this.estoqueEdit = {}
          this.listando()
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(
            erro.response ? erro.response.data.data : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    removeMovimentacao() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService.deletar(token, this.estoqueEdit.id).then((response) => {
        this.produtos = response.data.produtos
        this.isLoading = false
        this.$bvModal.hide('modal-remove-movimentacao')
        this.$bvModal.hide('modal-historico')
        this.listando()
      })
    },
    handleGetProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      produtoService.listar(token).then((response) => {
        this.produtos = response.data.produtos
        this.isLoading = false
      })
    },

    showHistoryByProduct(id) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estoqueService.findAllByProduct(token, id).then((response) => {
        this.historicos = response.data.estoques
        this.isLoading = false
        this.$bvModal.show('modal-historico')
      })
    },
    showRemoveStockProduct(estoque) {
      this.estoqueEdit = estoque
      this.$bvModal.show('modal-remove-movimentacao')
    },
    showEditStockProduct(estoque) {
      this.estoqueEdit = {}
      this.estoqueEdit = estoque
      this.$bvModal.show('modal-editar-movimentacao')
    },
    showModalNewStock() {
      this.estoqueEdit = {}
      this.$bvModal.show('modal-movimentacao')
    },
    findByDate() {
      if (
        this.filterDataInicial != undefined ||
        this.filterDataFinal != undefined ||
        this.filterProduto != undefined ||
        this.filterReceituario != undefined ||
        this.filterNota != undefined
      ) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        estoqueService
          .findAllByDate(token, this.filterDataInicial, this.filterDataFinal, this.filterProduto, this.filterReceituario, this.filterNota)
          .then((resposta) => {
            this.estoques = resposta.data.estoques
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.$bvToast.toast(
              error.response ? error.response.data.message : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.estoques = []
            this.rows = 1
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco stock-movement-page">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-7 mb-2">
            <div class="titulo">
              <i class="uil uil-exchange"></i>
              Movimentações de Estoque
            </div>
            <div class="subTitulo">
              Gerencie e rastreie todas as entradas, saídas e transferências de produtos em tempo real.
            </div>
          </div>
          <div class="col-md-5">
            <div class="movement-page-actions">
              <button class="btn btn-light" type="button" @click="$refs.btnexport.$el.click()">
                <i class="uil uil-export"></i>
                Exportar
              </button>
              <button class="btn btn-webreceita" type="button" @click="showModalNewStock()">
                <i class="uil uil-plus"></i>
                Nova Movimentação
              </button>
              <vue-excel-xlsx
                ref="btnexport"
                style="display: none"
                :data="estoqueExcel"
                :columns="columns"
                :filename="'estoques'"
                :sheetname="'estoques'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="movement-dashboard">
        <section class="movement-kpi-grid">
          <article class="movement-kpi-card">
            <span class="movement-kpi-icon is-transfer"><i class="uil uil-exchange"></i></span>
            <div>
              <small>Total do Mês</small>
              <strong>{{ totalMes }}</strong>
            </div>
          </article>
          <article class="movement-kpi-card is-entry">
            <span class="movement-kpi-icon is-entry"><i class="uil uil-arrow-up"></i></span>
            <div>
              <small>Volume de Entradas</small>
              <strong>{{ totalEntradas }}</strong>
            </div>
            <b>Entradas</b>
          </article>
          <article class="movement-kpi-card is-exit">
            <span class="movement-kpi-icon is-exit"><i class="uil uil-arrow-down"></i></span>
            <div>
              <small>Volume de Saídas</small>
              <strong>{{ totalSaidas }}</strong>
            </div>
            <b>Saídas</b>
          </article>
          <article class="movement-kpi-card">
            <span class="movement-kpi-icon is-neutral"><i class="uil uil-clipboard-notes"></i></span>
            <div>
              <small>Ajustes Pendentes</small>
              <strong>{{ ajustesPendentes }}</strong>
            </div>
            <b>Atenção</b>
          </article>
        </section>

        <section class="movement-filter-card">
          <div>
            <label>Produto ou SKU</label>
            <b-form-input v-model="filterProduto" placeholder="Ex: Monitor Dell U2422H" />
          </div>
          <div>
            <label>Tipo de Movimento</label>
            <b-form-select
              v-model="filterTipoMovimento"
              :options="[
                { value: '', text: 'Todos' },
                { value: 'E', text: 'Entrada' },
                { value: 'S', text: 'Saída' },
              ]"
            />
          </div>
          <div>
            <label>Período</label>
            <div class="movement-period-field">
              <i class="uil uil-calendar-alt"></i>
              <span>01/10/2023 - 31/10/2023</span>
            </div>
          </div>
          <button class="btn btn-webreceita is-soft" type="button" @click="findByDate">
            Filtrar
          </button>
          <button class="movement-refresh" type="button" @click="clearFilters">
            <i class="uil uil-redo"></i>
          </button>
        </section>

        <section class="movement-table-card">
          <div class="movement-table-head">
            <h2>Histórico Recente</h2>
            <span>Mostrando 1-{{ estoqueResumo.length }} de {{ estoquesFiltrados.length }} resultados</span>
          </div>

          <div class="movement-table-wrap">
            <table class="movement-table">
              <thead>
                <tr>
                  <th>Data/Hora</th>
                  <th>Tipo</th>
                  <th>Produto</th>
                  <th>Qtd</th>
                  <th>Origem / Destino</th>
                  <th>Operador</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in estoqueResumo" :key="`${item.id || index}-${item.data}`">
                  <td>
                    <strong>{{ formatDate(item.data) !== 'Invalid date' ? formatDate(item.data) : '24/10/2023' }}</strong>
                    <small>- {{ formatTime(item.data) }}</small>
                  </td>
                  <td>
                    <span :class="['movement-type', movementTypeClass(item.tipo_movimento)]">
                      <i :class="item.tipo_movimento === 'S' ? 'uil uil-arrow-down' : 'uil uil-arrow-up'"></i>
                      {{ movementTypeLabel(item.tipo_movimento) }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ item.nome || 'Monitor Dell 27” 4K' }}</strong>
                    <small>{{ productSku(item) }}</small>
                  </td>
                  <td>
                    <strong :class="['movement-quantity', movementTypeClass(item.tipo_movimento)]">
                      {{ movementQuantity(item) }}
                    </strong>
                  </td>
                  <td>{{ originDestination(item) }}</td>
                  <td>
                    <span class="movement-operator">
                      {{ operatorName(index).charAt(0) }}
                    </span>
                    {{ operatorName(index) }}
                  </td>
                  <td>
                    <span :class="['movement-status', movementStatusClass(item)]">
                      {{ movementStatus(item) }}
                    </span>
                  </td>
                  <td>
                    <button class="movement-view" type="button" @click="showHistoryByProduct(item.id_produto)">
                      <i class="uil uil-eye"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="!estoqueResumo.length">
                  <td colspan="8" class="movement-empty">
                    Nenhuma movimentação encontrada.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>

    <b-modal id="modal-remove-movimentacao" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja remover essa movimentação de estoque?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-remove-movimentacao')">Não</b-button>
        <b-button variant="danger" @click="removeMovimentacao">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-editar-movimentacao" title="Editar Estoque" title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo de Movimentação" label-for="input-1">
            <v-select class="style-select" :options="tipoMovimentos" :reduce="(item) => item.tipo_movimento"
              label="descricao" v-model="estoqueEdit.tipo_movimento">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Produto" label-for="input-1">
            <v-select class="style-select" :options="produtos" :reduce="(item) => item.id_produto" label="nome"
              v-model="estoqueEdit.id_produto">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Data de entrada" label-for="input-2">
            <b-form-datepicker id="datepicker-inicial" v-model="estoqueEdit.data" placeholder="Selecione a data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade" v-model="estoqueEdit.disponivel"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Estoque Minimo" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Estoque Minimo" v-model="estoqueEdit.minimo"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Estoque Máximo" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Estoque Máximo" v-model="estoqueEdit.maximo"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade Embalagens" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade Embalagens" v-model="estoqueEdit.quantidade"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="NF" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Número da NF" v-model="estoqueEdit.n_nf"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-1" label="Nº Receituário" label-for="input-1">
            <b-form-input id="input-1" type="text" placeholder="Número do Receituário" v-model="estoqueEdit.n_receita"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-editar-movimentacao')">Cancelar</b-button>
        <b-button variant="primary" @click="atualizar">Salvar</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-movimentacao" title="Movimentação de Estoque" title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo de Movimentação" label-for="input-1">
            <v-select class="style-select" :options="tipoMovimentos" :reduce="(item) => item.tipo_movimento"
              label="descricao" v-model="estoqueEdit.tipo_movimento">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Produto" label-for="input-1">
            <v-select class="style-select" :options="produtos" :reduce="(item) => item.id_produto" label="nome"
              v-model="estoqueEdit.id_produto">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Data de entrada" label-for="input-2">
            <b-form-datepicker id="datepicker-inicial" v-model="estoqueEdit.data" menu-class="w-100" calendar-width="100%"
              class="mb-2" placeholder="Selecione a data" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br" @input="get_data()">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Quantidade" label-for="input-1">
            <b-form-input id="input-1" type="number" placeholder="Quantidade" v-model="estoqueEdit.disponivel"
              required></b-form-input>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-movimentacao')">Cancelar</b-button>
        <b-button variant="primary" @click="salvar">Salvar</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-historico" title="Histórico por Produto" title-class="font-18" size="xl">
      <div class="row">
        <div class="col-md-12">
          <b-table striped hover responsive="sm" borderless bordered outlined small :items="historicos"
            :fields="historicoFields" show-empty>
            <template #empty="scope">
              <div class="row">
                <div class="col-md-12">
                  <span>Nenhum estoque encontrado!</span>
                </div>
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <button v-b-tooltip.hover title="Excluir" type="button" class="btn btn-light"
                @click="showRemoveStockProduct(row.item)">
                <i class="uil uil-trash-alt"></i>
              </button>
            </template>
            <template v-slot:cell(data)="row">
              {{
                formatDate(row.item.data) !== 'Invalid date'
                ? formatDate(row.item.data)
                : row.item.data
              }}
            </template>
            <template v-slot:cell(tipo_movimento)="row">
              <span v-if="row.item.tipo_movimento === 'E'" variant="primary" class="pl-2 pr-2 pt-1 pb-1">ENTRADA</span>
              <span v-else-if="row.item.tipo_movimento === 'S'" variant="info" class="pl-2 pr-2 pt-1 pb-1">SAÍDA</span>
            </template>
          </b-table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-historico')">Fechar</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco.stock-movement-page {
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  margin-top: 24px;
  padding: 32px;
  position: relative;
}

.stock-movement-page .titulo {
  align-items: center;
  color: #008e75;
  display: flex;
  font-size: 25px;
  font-weight: 800;
  gap: 8px;
  line-height: 1.2;
  margin-bottom: 8px;
}

.stock-movement-page .subTitulo {
  color: #536074;
  font-size: 14px;
}

.stock-movement-page .borda {
  border-bottom: 1px solid #edeff4;
  margin: 15px 0 18px;
}

.movement-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.movement-page-actions .btn,
.movement-filter-card .btn {
  align-items: center;
  border-radius: 5px;
  display: inline-flex;
  font-weight: 700;
  gap: 7px;
  height: 42px;
  justify-content: center;
  margin: 0;
  min-width: 130px;
  padding: 0 18px;
}

.btn-light {
  background: #fff;
  border: 1px solid #d8dee8;
  color: #172033;
}

.btn-webreceita {
  background: #008e75;
  border-color: #008e75;
  color: #fff;
}

.btn-webreceita.is-soft {
  background: #e4f6f0;
  border-color: #bee2dc;
  color: #008e75;
}

.movement-dashboard {
  background: #f5f7fb;
  display: grid;
  gap: 18px;
  margin: 0 -32px -32px;
  padding: 18px 32px 32px;
}

.movement-kpi-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.movement-kpi-card,
.movement-filter-card,
.movement-table-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.movement-kpi-card {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: auto 1fr auto;
  min-height: 118px;
  padding: 18px 20px;
}

.movement-kpi-card.is-entry {
  border-left: 4px solid #008e75;
}

.movement-kpi-card.is-exit {
  border-left: 4px solid #b45d59;
}

.movement-kpi-icon {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  font-size: 22px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.movement-kpi-icon.is-transfer { background: #dff3ec; color: #008e75; }
.movement-kpi-icon.is-entry { background: #e4f6f0; color: #008e75; }
.movement-kpi-icon.is-exit { background: #ffe9ed; color: #b45d59; }
.movement-kpi-icon.is-neutral { background: #eef1f2; color: #536074; }

.movement-kpi-card small {
  color: #536074;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.movement-kpi-card strong {
  color: #172033;
  display: block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}

.movement-kpi-card b {
  align-self: start;
  color: #008e75;
  font-size: 11px;
  font-weight: 800;
}

.movement-kpi-card.is-exit b {
  color: #b45d59;
}

.movement-filter-card {
  align-items: end;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(220px, 1.2fr) minmax(160px, 0.7fr) minmax(230px, 1fr) auto auto;
  padding: 22px;
}

.movement-filter-card label {
  color: #536074;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.movement-filter-card .form-control,
.movement-filter-card .custom-select,
.movement-period-field {
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #536074;
  font-weight: 700;
  height: 42px;
}

.movement-period-field {
  align-items: center;
  background: #fff;
  display: flex;
  gap: 8px;
  padding: 0 12px;
}

.movement-refresh {
  align-items: center;
  background: #fff;
  border: 1px solid #bee2dc;
  border-radius: 5px;
  color: #008e75;
  display: inline-flex;
  font-size: 18px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.movement-table-card {
  overflow: hidden;
}

.movement-table-head {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 22px;
}

.movement-table-head h2 {
  color: #172033;
  font-size: 18px;
  font-weight: 800;
  margin: 0;
}

.movement-table-head span {
  color: #647084;
  font-size: 12px;
  font-weight: 700;
}

.movement-table-wrap {
  overflow-x: auto;
}

.movement-table {
  border-collapse: collapse;
  min-width: 980px;
  width: 100%;
}

.movement-table th {
  background: #eef3fb;
  color: #536074;
  font-size: 11px;
  font-weight: 800;
  padding: 14px 20px;
  text-align: left;
  text-transform: uppercase;
}

.movement-table td {
  border-top: 1px solid #e7edf4;
  color: #172033;
  font-size: 13px;
  padding: 18px 20px;
  vertical-align: middle;
}

.movement-table td strong {
  display: block;
  font-weight: 800;
}

.movement-table td small {
  color: #7b8796;
  display: block;
  font-size: 11px;
  margin-top: 3px;
}

.movement-type {
  align-items: center;
  display: inline-flex;
  font-weight: 800;
  gap: 8px;
}

.movement-type i {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.movement-type.is-entry { color: #008e75; }
.movement-type.is-exit { color: #b45d59; }
.movement-type.is-transfer { color: #536074; }
.movement-type.is-entry i { background: #e4f6f0; }
.movement-type.is-exit i { background: #ffe9ed; }
.movement-type.is-transfer i { background: #eef1f2; }

.movement-quantity {
  font-size: 15px;
}

.movement-quantity.is-entry { color: #008e75; }
.movement-quantity.is-exit { color: #b45d59; }

.movement-operator {
  align-items: center;
  background: #e6f0ef;
  border-radius: 50%;
  color: #7b8796;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  height: 24px;
  justify-content: center;
  margin-right: 8px;
  width: 24px;
}

.movement-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  padding: 5px 12px;
  text-transform: uppercase;
}

.movement-status.is-done {
  background: #e4f6f0;
  color: #008e75;
}

.movement-status.is-pending {
  background: #e8f1ff;
  color: #47739e;
}

.movement-view {
  background: transparent;
  border: 0;
  color: #536074;
  font-size: 18px;
  padding: 0;
}

.movement-empty {
  color: #647084;
  text-align: center;
}

@media (max-width: 1199px) {
  .movement-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .movement-filter-card {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .movement-page-actions,
  .movement-table-head {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .movement-page-actions .btn,
  .movement-filter-card .btn,
  .movement-filter-card .form-control,
  .movement-filter-card .custom-select {
    width: 100%;
  }

  .movement-kpi-grid,
  .movement-filter-card {
    grid-template-columns: 1fr;
  }
}
</style>
